
const DAY_IN_MILLIS = 1000 * 60 * 60 * 24;

export const padLeft = (str: unknown, len: number, ch: string) => {
  const argStr = String(str);
  const pad = String(ch).length === 0 ? " " : ch;
  if (argStr.padStart === undefined) {
    return pad.repeat(len - argStr.length) + argStr;
  } else {
    return String(argStr).padStart(len, pad);
  }
};

export const getToday = (dateLineHour: number): Date => {
  const argDateLineHour = dateLineHour ? dateLineHour : 0;
  const today = new Date();
  const h = today.getHours();
  if (h < argDateLineHour) {
    const pso2Today = new Date(today.getTime() - DAY_IN_MILLIS);
    return new Date(pso2Today.getFullYear(), pso2Today.getMonth(), pso2Today.getDate());
  }
  return new Date(today.getFullYear(), today.getMonth(), today.getDate());
};

export const getTodayDoW = (dateLineHour: number): number => {
  const today = getToday(dateLineHour);
  return today.getDay();
};

export const getTodayString = (dateLineHour: number): string => {
  const today = getToday(dateLineHour);
  const y = today.getFullYear();
  const m = today.getMonth() + 1;
  const d = today.getDate();
  const yy = padLeft(y, 2, "0");
  const mm = padLeft(m, 2, "0");
  const dd = padLeft(d, 2, "0");
  return yy + "-" + mm + "-" + dd;
};

export const getNearestDay = (dateLineHour: number, dayOfWeek: number): Date => {
  const today = getToday(dateLineHour);
  const dow = today.getDay();
  if (dow === dayOfWeek) {
    return today;
  }
  let sa = dow - dayOfWeek;
  if (sa < 0) {
    sa += 7;
  }
  const nearestDay = new Date(today.getTime() - DAY_IN_MILLIS * sa);
  return nearestDay;
};

export const fixTodayString = (dateString: string): string => {
  const nums = dateString.split("-");
  if (nums.length !== 3) {
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);
    return year + "-" + month + "-" + day;
  } else {
    return dateString;
  }
};
